import { useQuery } from '@tanstack/react-query';
import {
  getPlannerAreas,
  getPlannerJobCategories,
  getPlannerJobPriorities,
} from '../api/plannerLookupsApi';

export function usePlannerJobCategories() {
  return useQuery({
    queryKey: ['planner', 'lookups', 'job-categories'],
    queryFn: getPlannerJobCategories,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
}

export function usePlannerJobPriorities() {
  return useQuery({
    queryKey: ['planner', 'lookups', 'job-priorities'],
    queryFn: getPlannerJobPriorities,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
}

export function usePlannerAreas() {
  return useQuery({
    queryKey: ['planner', 'lookups', 'areas'],
    queryFn: getPlannerAreas,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
}
